export default "__VITE_ASSET__CZYEdBPf__"